import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Avatar from '../../../components/avatar/avatar.component';
import EditProfile from './edit-profile';
import { IDatingProfileModel } from '../../../models/dating.model';
import { IOption } from '../../../select/select.component';
import { fetchUrlImages } from '../../../api';
import { datingService } from '../../../services/dating.service';
import toast from 'react-hot-toast';
import DialogComponent from '../../../components/dialog/dialog.component';
import { IDatingInfo } from '../../../hooks/use-dating/useDating';
import { useSelector } from 'react-redux';
import { RootState } from '../../../configuration';

interface ProfileBannerProps {
  profile?: IDatingProfileModel;
  changeTab?: any;
  tabActive?: any;
  cities?: IOption[];
  getDatingProfile?: () => void;
  totalMatchRequests?: number;
  datingInfo: IDatingInfo;
}

const Tabs = [
  {
    label: 'Khám phá',
    value: 'connection',
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_755_40862)">
          <path
            d="M3.36378 2.62442C3.12978 4.94289 -1.31629 5.75818 0.380236 9.07028C0.467987 6.26773 4.82631 4.40786 3.36378 2.62442ZM15.5905 5.29958C14.8007 3.92378 12.6947 2.95563 12.8994 1.22314C11.3199 4.94289 15.1225 5.5034 15.5027 9.22314C16 8.1276 16.2925 6.52251 15.5905 5.29958Z"
            fill="#F3476D"
          />
          <path
            d="M11.1152 15.4394C10.7935 15.5413 10.4717 15.6432 10.0914 15.7196C12.8995 14.1145 12.5192 12.1527 11.5247 10.5477C11.2322 11.1591 10.5887 11.5668 9.56494 11.8215C10.735 10.9298 10.8812 9.96166 10.7057 8.6623C10.4132 7.2865 9.44793 6.44574 8.16091 6.14001C9.24318 7.23555 9.06768 8.56039 8.16091 9.60498C6.87389 11.261 5.06036 10.14 6.08413 8.38205C4.3876 9.04447 2.92508 10.9553 3.45159 13.3757C3.68559 14.2164 4.29985 15.1082 5.32362 15.6687C5.00186 15.6432 4.68011 15.5668 4.35835 15.4394C2.60333 14.191 2.13532 12.6368 2.22307 10.8279C2.28157 9.42663 3.8611 7.2865 5.20662 6.47122C5.55762 7.13364 6.75689 7.23555 7.19565 6.39479C7.4004 5.96166 7.6344 4.96803 7.6344 4.53491C11.437 4.76421 11.8757 7.99988 11.7587 9.83428C11.9927 9.83428 12.8702 9.3502 13.0457 9.22281C14.0695 10.726 14.2158 13.7324 11.1152 15.4394Z"
            fill="#FF8A1D"
          />
          <path
            d="M11.1151 15.4395C14.1864 13.7325 14.0694 10.7261 13.0164 9.27389C12.8409 9.40127 11.9634 9.88535 11.7294 9.88535C11.8464 8.07643 11.4076 4.84076 7.60507 4.58599C7.60507 5.04459 7.37107 6.01274 7.16631 6.44586C6.75681 7.28662 5.55754 7.18471 5.17728 6.52229C3.83176 7.3121 2.25224 9.47771 2.19373 10.879C2.13523 12.6879 2.60324 14.2675 4.35827 15.4904C2.07673 14.6497 0.497208 11.7452 0.877464 9.80892C1.28697 7.5414 2.69099 5.85987 4.50452 4.30573C5.79154 3.18471 7.51732 1.98726 8.83359 0C9.91586 1.93631 10.9396 3.28662 12.1096 4.6879C13.7184 6.49682 14.5959 7.97452 14.8007 10.242C14.9469 12.535 13.8354 14.5478 11.1151 15.4395Z"
            fill="#F3476D"
          />
          <path
            d="M10.1206 15.7198C9.68188 15.8472 9.21387 15.9491 8.71661 15.9746C10.5301 15.7453 11.3199 13.8345 10.8226 12.9173C10.6179 13.5287 9.27237 13.8345 8.68736 13.809C8.48261 13.7835 8.0731 13.6052 8.0146 13.3249C7.98535 13.1466 8.10235 12.8918 8.21936 12.7389C8.74586 12.102 8.68736 11.2357 7.92685 10.7262C7.75135 11.7963 5.82082 12.3313 4.85555 11.6943C4.56305 12.4842 4.6508 13.2485 4.9433 14.1147C5.32356 15.2103 6.11332 15.8472 7.25409 15.9746C6.58133 15.9236 5.90857 15.8217 5.32356 15.7198C4.29979 15.1593 3.68553 14.2421 3.45153 13.4268C2.92502 11.0064 4.38754 9.09562 6.08407 8.4332C5.08956 10.1657 6.87383 11.2867 8.16085 9.65613C9.06762 8.61155 9.24312 7.2867 8.16085 6.19116C9.44787 6.47142 10.4131 7.31218 10.7056 8.71346C10.9104 10.0128 10.7349 10.9555 9.56488 11.8727C10.5886 11.6179 11.2322 11.2103 11.5247 10.5988C12.5192 12.1275 12.9287 14.1147 10.1206 15.7198Z"
            fill="#FBB7C5"
          />
          <path
            d="M8.71667 15.9746C8.57042 15.9746 8.45342 16.0001 8.33642 16.0001C8.10241 16.0001 7.83916 16.0001 7.57591 16.0001C7.54666 16.0001 7.54666 16.0001 7.51741 16.0001C7.42965 16.0001 7.3419 16.0001 7.25415 16.0001H7.2249C6.08413 15.8982 5.29437 15.2358 4.91411 14.1402C4.62161 13.274 4.53386 12.5097 4.82636 11.7199C5.79163 12.3568 7.75141 11.7963 7.89766 10.7517C8.65817 11.2613 8.68742 12.1275 8.19017 12.7644C8.07316 12.9428 7.95616 13.1721 7.98541 13.3504C8.04391 13.6562 8.45342 13.809 8.65817 13.8345C9.24318 13.86 10.618 13.5543 10.7935 12.9428C11.32 13.8345 10.5302 15.7453 8.71667 15.9746Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_755_40862">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    label: 'Yêu cầu kết nối ',
    value: 'requests',
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4667 8.2666C9.70006 8.2666 8.26672 9.69995 8.26672 11.4666C8.26672 12.0666 8.43339 12.6333 8.73339 13.1133C9.28672 14.0399 10.3001 14.6666 11.4667 14.6666C12.6334 14.6666 13.6534 14.0399 14.2001 13.1133C14.4934 12.6333 14.6667 12.0666 14.6667 11.4666C14.6667 9.69995 13.2334 8.2666 11.4667 8.2666ZM13.0534 11.0466L11.3467 12.6199C11.2534 12.7066 11.1267 12.7533 11.0067 12.7533C10.8801 12.7533 10.7534 12.7066 10.6534 12.6066L9.86672 11.8199C9.67339 11.6266 9.67339 11.3066 9.86672 11.1133C10.0601 10.9199 10.3801 10.9199 10.5734 11.1133L11.0201 11.5599L12.3734 10.3066C12.5734 10.1199 12.8934 10.1333 13.0801 10.3333C13.2667 10.5399 13.2534 10.8599 13.0534 11.0466Z"
          fill="#F3476D"
        />
        <path
          opacity="0.4"
          d="M14.6667 5.79331C14.6667 6.58665 14.54 7.31998 14.32 7.99998C14.18 8.44665 14 8.87331 13.7867 9.26664C13.2 8.64664 12.38 8.26664 11.4667 8.26664C9.70004 8.26664 8.26671 9.69999 8.26671 11.4667C8.26671 12.2867 8.58004 13.0333 9.08671 13.6C8.84004 13.7133 8.61337 13.8066 8.41337 13.8733C8.18671 13.9533 7.81337 13.9533 7.58671 13.8733C5.98004 13.3266 2.73337 11.3333 1.68004 7.99998C1.46004 7.31998 1.33337 6.58665 1.33337 5.79331C1.33337 3.73331 2.99338 2.06665 5.04004 2.06665C6.24671 2.06665 7.32671 2.6533 8.00004 3.5533C8.67337 2.6533 9.75337 2.06665 10.96 2.06665C13.0067 2.06665 14.6667 3.73331 14.6667 5.79331Z"
          fill="#F54B6D"
        />
      </svg>
    ),
  },
  {
    label: 'Profile',
    value: 'profile',
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M8.00004 14.6734C11.6819 14.6734 14.6667 11.6887 14.6667 8.00675C14.6667 4.32486 11.6819 1.34009 8.00004 1.34009C4.31814 1.34009 1.33337 4.32486 1.33337 8.00675C1.33337 11.6887 4.31814 14.6734 8.00004 14.6734Z"
          fill="#F3476D"
        />
        <path
          d="M8 4.62671C6.62 4.62671 5.5 5.74671 5.5 7.12671C5.5 8.48004 6.56 9.58004 7.96667 9.62004C7.98667 9.62004 8.01333 9.62004 8.02667 9.62004C8.04 9.62004 8.06 9.62004 8.07333 9.62004C8.08 9.62004 8.08667 9.62004 8.08667 9.62004C9.43333 9.57338 10.4933 8.48004 10.5 7.12671C10.5 5.74671 9.38 4.62671 8 4.62671Z"
          fill="#F3476D"
        />
        <path
          d="M12.52 12.9066C11.3333 13.9999 9.74665 14.6732 7.99998 14.6732C6.25331 14.6732 4.66665 13.9999 3.47998 12.9066C3.63998 12.2999 4.07331 11.7466 4.70665 11.3199C6.52665 10.1066 9.48665 10.1066 11.2933 11.3199C11.9333 11.7466 12.36 12.2999 12.52 12.9066Z"
          fill="#F3476D"
        />
      </svg>
    ),
  },
  {
    label: 'Album ảnh',
    value: 'album',
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.6667 5.20659V9.26659L13.58 8.33325C13.06 7.88659 12.22 7.88659 11.7 8.33325L8.92671 10.7133C8.40671 11.1599 7.56671 11.1599 7.04671 10.7133L6.82004 10.5266C6.34671 10.1133 5.59337 10.0733 5.06004 10.4333L1.78004 12.6333L1.70671 12.6866C1.46004 12.1533 1.33337 11.5199 1.33337 10.7933V5.20659C1.33337 2.77992 2.78004 1.33325 5.20671 1.33325H10.7934C13.22 1.33325 14.6667 2.77992 14.6667 5.20659Z"
          fill="#F3476D"
        />
        <path
          d="M6 6.91992C6.87629 6.91992 7.58666 6.20954 7.58666 5.33325C7.58666 4.45696 6.87629 3.74658 6 3.74658C5.1237 3.74658 4.41333 4.45696 4.41333 5.33325C4.41333 6.20954 5.1237 6.91992 6 6.91992Z"
          fill="#F3476D"
        />
        <path
          d="M14.6667 9.26662V10.7933C14.6667 13.22 13.22 14.6666 10.7933 14.6666H5.20666C3.50666 14.6666 2.28 13.9533 1.70667 12.6866L1.78 12.6333L5.06 10.4333C5.59333 10.0733 6.34666 10.1133 6.82 10.5266L7.04666 10.7133C7.56666 11.16 8.40666 11.16 8.92666 10.7133L11.7 8.33329C12.22 7.88662 13.06 7.88662 13.58 8.33329L14.6667 9.26662Z"
          fill="#F3476D"
        />
      </svg>
    ),
  },
  {
    label: 'Chat',
    value: 'chat',
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12.3133 11.2199L12.5733 13.3266C12.64 13.8799 12.0466 14.2666 11.5733 13.9799L8.77998 12.3199C8.47331 12.3199 8.17332 12.2999 7.87998 12.2599C8.37332 11.6799 8.66665 10.9466 8.66665 10.1532C8.66665 8.25991 7.02665 6.7266 4.99998 6.7266C4.22665 6.7266 3.51332 6.94659 2.91998 7.33325C2.89998 7.16659 2.89331 6.99991 2.89331 6.82658C2.89331 3.79325 5.52665 1.33325 8.77998 1.33325C12.0333 1.33325 14.6666 3.79325 14.6666 6.82658C14.6666 8.62658 13.74 10.2199 12.3133 11.2199Z"
          fill="#F3476D"
        />
        <path
          d="M8.66671 10.1532C8.66671 10.9465 8.37338 11.6799 7.88005 12.2599C7.22005 13.0599 6.17337 13.5732 5.00004 13.5732L3.26004 14.6065C2.96671 14.7865 2.59337 14.5399 2.63337 14.1999L2.80004 12.8866C1.90671 12.2666 1.33337 11.2732 1.33337 10.1532C1.33337 8.97986 1.96004 7.94654 2.92004 7.33321C3.51338 6.94654 4.22671 6.72656 5.00004 6.72656C7.02671 6.72656 8.66671 8.25986 8.66671 10.1532Z"
          fill="#F3476D"
        />
      </svg>
    ),
  },
];

const ProfileBanner = ({
  profile,
  changeTab,
  tabActive,
  cities,
  datingInfo,
  getDatingProfile,
  totalMatchRequests,
}: ProfileBannerProps) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [isNotValidProfile, setIsNotValidProfile] = useState<boolean>(false);
  const userProfile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const onUploadAvatar = async (files: any) => {
    try {
      const file = files[0];
      const formData = new FormData();
      formData.append('type', file);
      const res = await fetchUrlImages(formData);
      console.log('❤️ ~ onUploadAvatar ~ res:', res);
      profile && (profile.avatar = res[0].url);
      profile && (profile.albumUrls = [res[0].url]);
      await datingService.updateDatingProfile(profile as IDatingProfileModel);
      toast.success('Cập nhật thông tin thành công');
      getDatingProfile && getDatingProfile();
    } catch (error) {
      toast.error('Không thể cập nhật ảnh đại diện');
      console.error('Error uploading avatar:', error);
    }
  };

  const onTabClick = (value: string) => {
    if (value === 'update_profile') {
      setVisible(true);
      return;
    }
    if (!profile?.profileId && value!=='profile') {
      setIsNotValidProfile(true);
      return;
    }
    changeTab && changeTab(value);
  };

  const navigator = useNavigate();

  return (
    <div className="  flex flex-col w-full md:max-w-[306px] gap-6">
      <EditProfile
        getDatingProfile={getDatingProfile}
        cities={cities}
        profile={profile}
        visible={visible}
        setVisible={setVisible}
      />
      <div className="border border-[#DEE0E6] dark:border-slate-700 rounded-xl p-3">
        <div className="flex flex-col">
          <div className="flex gap-2 px-3    py-2">
            <Avatar
              customUpload="!inset-0 !opacity-0 !hover:opacity-100 "
              avatar={_.get(profile, 'avatar', '')}
              label={_.get(profile, 'nickname', '')}
              size="sm"
              uploaded
              onUploadAvatar={onUploadAvatar}
              // onUploadSuccess={onUpdateSuccess}
              preview={false}
            />
            <div className="flex flex-col gap-1">
              <div
                className={`  font-bold text-[#111827]  dark:text-white text-sm`}
              >
                {_.get(
                  profile,
                  'nickname',
                  '( Vui lòng cập nhật tên hiển thị )'
                )}
              </div>
              <div className="text-[#080809] truncate dark:text-white text-xs">
                {_.get(profile, 'description')}
              </div>
            </div>
          </div>

          <ul className="flex flex-col gap-[10px]">
            <li className="px-3 flex gap-1 py-2 border-b border-[#E5E7EB] dark:border-slate-700 items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_751_6550)">
                  <path
                    d="M3.36378 2.62448C3.12978 4.94295 -1.31629 5.75824 0.380236 9.07034C0.467987 6.26779 4.82631 4.40792 3.36378 2.62448ZM15.5905 5.29964C14.8007 3.92384 12.6947 2.95569 12.8994 1.22321C11.3199 4.94295 15.1225 5.50346 15.5027 9.2232C16 8.12766 16.2925 6.52257 15.5905 5.29964Z"
                    fill="#BFC6E3"
                  />
                  <path
                    d="M11.1152 15.4395C10.7935 15.5414 10.4717 15.6433 10.0914 15.7197C12.8995 14.1147 12.5192 12.1529 11.5247 10.5478C11.2322 11.1592 10.5887 11.5669 9.56494 11.8217C10.735 10.9299 10.8812 9.96179 10.7057 8.66242C10.4132 7.28663 9.44793 6.44586 8.16091 6.14013C9.24318 7.23567 9.06768 8.56051 8.16091 9.6051C6.87389 11.2611 5.06036 10.1401 6.08413 8.38217C4.3876 9.04459 2.92508 10.9554 3.45159 13.3758C3.68559 14.2166 4.29985 15.1083 5.32362 15.6688C5.00186 15.6433 4.68011 15.5669 4.35835 15.4395C2.60333 14.1911 2.13532 12.6369 2.22307 10.828C2.28157 9.42675 3.8611 7.28663 5.20662 6.47134C5.55762 7.13376 6.75689 7.23567 7.19565 6.39491C7.4004 5.96179 7.6344 4.96816 7.6344 4.53503C11.437 4.76433 11.8757 8 11.7587 9.8344C11.9927 9.8344 12.8702 9.35032 13.0457 9.22293C14.0695 10.7261 14.2158 13.7325 11.1152 15.4395Z"
                    fill="#D6DAEC"
                  />
                  <path
                    d="M11.1151 15.4395C14.1864 13.7325 14.0694 10.7261 13.0164 9.27389C12.8409 9.40127 11.9634 9.88535 11.7294 9.88535C11.8464 8.07643 11.4076 4.84076 7.60507 4.58599C7.60507 5.04459 7.37107 6.01274 7.16631 6.44586C6.75681 7.28662 5.55754 7.18471 5.17728 6.52229C3.83176 7.3121 2.25224 9.47771 2.19373 10.879C2.13523 12.6879 2.60324 14.2675 4.35827 15.4904C2.07673 14.6497 0.497208 11.7452 0.877464 9.80892C1.28697 7.5414 2.69099 5.85987 4.50452 4.30573C5.79154 3.18471 7.51732 1.98726 8.83359 0C9.91586 1.93631 10.9396 3.28662 12.1096 4.6879C13.7184 6.49682 14.5959 7.97452 14.8007 10.242C14.9469 12.535 13.8354 14.5478 11.1151 15.4395Z"
                    fill="#9FA9CF"
                  />
                  <path
                    d="M10.1206 15.7198C9.68188 15.8472 9.21387 15.9491 8.71661 15.9745C10.5301 15.7452 11.3199 13.8344 10.8226 12.9172C10.6179 13.5287 9.27237 13.8344 8.68736 13.8089C8.48261 13.7835 8.0731 13.6051 8.0146 13.3249C7.98535 13.1465 8.10235 12.8917 8.21936 12.7389C8.74586 12.1019 8.68736 11.2357 7.92685 10.7261C7.75135 11.7962 5.82082 12.3312 4.85555 11.6943C4.56305 12.4841 4.6508 13.2484 4.9433 14.1147C5.32356 15.2102 6.11332 15.8472 7.25409 15.9745C6.58133 15.9236 5.90857 15.8217 5.32356 15.7198C4.29979 15.1593 3.68553 14.2421 3.45153 13.4268C2.92502 11.0064 4.38754 9.09556 6.08407 8.43314C5.08956 10.1656 6.87383 11.2866 8.16085 9.65607C9.06762 8.61148 9.24312 7.28664 8.16085 6.1911C9.44787 6.47136 10.4131 7.31212 10.7056 8.71339C10.9104 10.0128 10.7349 10.9554 9.56488 11.8726C10.5886 11.6179 11.2322 11.2102 11.5247 10.5987C12.5192 12.1274 12.9287 14.1147 10.1206 15.7198Z"
                    fill="#E4E7F5"
                  />
                  <path
                    d="M8.71667 15.9745C8.57042 15.9745 8.45342 16 8.33642 16C8.10241 16 7.83916 16 7.57591 16C7.54666 16 7.54666 16 7.51741 16C7.42965 16 7.3419 16 7.25415 16H7.2249C6.08413 15.8981 5.29437 15.2357 4.91411 14.1401C4.62161 13.2739 4.53386 12.5095 4.82636 11.7197C5.79163 12.3567 7.75141 11.7962 7.89766 10.7516C8.65817 11.2611 8.68742 12.1274 8.19017 12.7643C8.07316 12.9427 7.95616 13.172 7.98541 13.3503C8.04391 13.656 8.45342 13.8089 8.65817 13.8344C9.24318 13.8599 10.618 13.5541 10.7935 12.9427C11.32 13.8344 10.5302 15.7452 8.71667 15.9745Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_751_6550">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="text-sm text-[#111827] dark:text-slate-200 py-[6px]">
                {datingInfo.remainingMatchRequests}&nbsp;<b>lượt kết nối</b>
              </span>
            </li>
            <li
              onClick={() => navigator('/dating?tab=requests&subtab=match')}
              className="px-3 cursor-pointer flex gap-1 py-2 border-b border-[#E5E7EB] dark:border-slate-700 items-center"
            >
              <span className="text-sm text-[#111827] dark:text-slate-200 py-[6px]">
                {datingInfo.totalMatchedProfiles}&nbsp;<b>đã kết nối</b>
              </span>
            </li>
            <li
              onClick={() =>
                navigator('/dating?tab=requests&subtab=send-request')
              }
              className="px-3 cursor-pointer flex gap-1 py-2 border-b border-[#E5E7EB] dark:border-slate-700 items-center"
            >
              <span className="text-sm text-[#111827] dark:text-slate-200 py-[6px]">
                {datingInfo.totalSentMatchRequests}&nbsp;<b>đã gửi kết nối</b>
              </span>
            </li>
            <li className="px-3 flex gap-1 py-2 border-b border-[#E5E7EB] dark:border-slate-700 items-center">
              <span className="text-sm text-[#111827] dark:text-slate-200 py-[6px]">
                {userProfile?.coin || 0}
                &nbsp;<b>Số dư (Ca)</b>
              </span>
            </li>
          </ul>
        </div>
      </div>
      {!profile?.profileId && tabActive !== 'profile' && (
        <button
          type="button"
          onClick={() => changeTab && changeTab('profile')}
          className="flex flex-col gap-0.5 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-left hover:bg-sky-100 dark:border-sky-900/40 dark:bg-sky-900/20"
        >
          <span className="text-sm font-semibold text-sky-800 dark:text-sky-200">
            Hồ sơ hẹn hò của bạn chưa hoàn thiện
          </span>
          <span className="text-xs text-sky-700 underline dark:text-sky-300">
            Hoàn thiện ngay để bắt đầu kết nối →
          </span>
        </button>
      )}
      <div className=" max-h-[520px] overflow-y-auto ">
        <TabsComponent
          tabActive={tabActive}
          changeTab={onTabClick}
          totalMatchRequests={totalMatchRequests || 0}
        />
      </div>
      <DialogComponent
        size="xl"
        visible={isNotValidProfile}
        onClose={() => setIsNotValidProfile(false)}
        title="Hoàn thiện hồ sơ hẹn hò"
        placement="CENTER"
      >
        <div className="p-6">
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Bạn cần hoàn thiện hồ sơ hẹn hò (tên, giới thiệu, ảnh…) trước khi sử
            dụng tính năng này.
          </p>
          <div className="mt-5 flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setIsNotValidProfile(false)}
              className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
            >
              Để sau
            </button>
            <button
              type="button"
              onClick={() => {
                setIsNotValidProfile(false);
                changeTab && changeTab('profile');
              }}
              className="rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-700"
            >
              Hoàn thiện ngay
            </button>
          </div>
        </div>
      </DialogComponent>
    </div>
  );
};

const TabsComponent = ({
  tabActive,
  changeTab,
  totalMatchRequests,
}: {
  tabActive: string;
  changeTab: any;
  totalMatchRequests: number;
}) => {
  return (
    <div className="box border border-[#DEE0E6] dark:border-slate-700 bg-[#D9D9D9] rounded-xl dark:bg-dark2">
      <div className="flex justify-between h-[53px] px-4 py-[18px] relative text-black ">
        <div className=" absolute inset-0 ">
          <svg
            width="201"
            height="53"
            viewBox="0 0 201 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0H153V53H0V12Z"
              className="fill-white dark:fill-slate-800"
            />
            <path
              d="M153 0C156.57 0 159.844 1.98058 161.502 5.14192L175.465 31.7732C180.81 41.9673 190.001 49.6077 201 53H153V0Z"
              className="fill-white dark:fill-slate-800"
            />
          </svg>
        </div>
      </div>
      <nav className="bg-white dark:bg-dark2 px-4 gap-[10px] rounded-xl rounded-tl-none flex flex-col w-full   text-gray-600 font-medium text-[15px]  dark:text-white max-md:w-full max-md:overflow-x-auto">
        {Tabs.map((tab) => (
          <div
            key={tab.value}
            className={` flex items-center cursor-pointer border-b border-b-[#E5E7EB] dark:border-b-slate-700 last:border-none   px-3 py-2 ${
              tabActive === tab.value && 'bg-white dark:bg-slate-700 font-bold'
            } `}
            onClick={() => changeTab && changeTab(tab.value)}
          >
            <div className="flex items-center gap-2">
              {tab.icon}
              {tab.label}
              {tab.value === 'requests' && (
                <span className="text-[#E31777]">({totalMatchRequests})</span>
              )}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default ProfileBanner;
